<template>
	<div class="popup-overlay" v-if="visible">
		<div class="wrap">
			<div class="title">
				优惠券
				<span class="close" @click="close">×</span>
			</div>

			<div class="scroll-content">
				<div class="content" v-for="(item, index) in couponActivityVo" :key="'coupon' + index">
					<div class="flex top rel">
						<div class="left">
							<span class="tips font10">发放主体：{{ getName(item.companyCode) }}</span>
							<span class="price price-tag">
								<i>¥</i>
								{{ item.couponAmount }}
							</span>
							<span class="font10 price-tag">满{{ item.satisfyAmount }}可用</span>
						</div>

						<div class="right">
							<div class="flex">
								<i class="iconfont icon-dingdan_quan"></i>
								<span style="flex: 1">{{ item.exhibitionNote }}</span>
							</div>
							<span>有效期：{{ formatDate(item.effectiveDate) }} ～ {{ formatDate(item.expirationDate) }}</span>

							<button v-if="!item.userReceiveId" class="btn-radius btn-mini" @click="collectCoupon(item)">领取</button>
							<i v-else class="ylq iconfont icon-youhuiquantubiao_yilingqu"></i>

							<button v-if="item.userReceiveId" class="btn-radius btn-mini go-collect" @click="toCollect(item)">去凑单</button>
						</div>

						<span v-if="!item.userReceiveId" class="coupon-tips">每人限领{{ item.limitProvideNum }}张，数量有限，先到先得。</span>
					</div>

					<ProductList
						:couponActivityVo="couponActivityVo"
						:item="item"
						:receives="receives"
						:checkedIds="checkedIds"
						@choose="changeList"
						@changeCoupon="changeCoupon"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import dayjs from 'dayjs';
import ProductList from './ProductList.vue';
import { collectCoupon as collectCouponApi } from '@/api/goods.js';
import { showToast } from 'vant';
import { getStorageSync, setStorageSync } from '@/utils/storage.js';

const visible = ref(false);
const couponActivityVo = ref([]);
const sub = ref({});
const checkedIds = ref([]);

// 已领取的优惠券列表
const receives = computed(() => {
	return couponActivityVo.value.filter(item => item.chooseSgin === 1);
});

// 打开弹窗
const open = subData => {
	couponActivityVo.value = subData.couponActivityVo;
	sub.value = subData;
	checkedIds.value = subData.list.filter(item => item.checked).map(item => item.productId + (item.agreementPriceId || ''));
	visible.value = true;
};

// 关闭弹窗
const close = () => {
	changeList();
	visible.value = false;
};

// 更新选中状态
const changeList = () => {
	sub.value.list.forEach(item => {
		item.checked = checkedIds.value.includes(item.productId + (item.agreementPriceId || ''));
	});
};

// 格式化日期
const formatDate = date => {
	return dayjs(date).format('YYYY-MM-DD');
};

// 获取公司名称（从 localStorage）
const getMutilData = () => {
	try {
		const data = getStorageSync('getMutil');
		return Array.isArray(data) ? data : [];
	} catch (e) {
		console.error('读取 localStorage 失败:', e);
		return [];
	}
};

// 领取优惠券
const collectCoupon = async item => {
	const getMutil = getMutilData();
	const res = getMutil.find(row => row.companyCode === item.companyCode);

	if (!res?.first) {
		showToast({
			message: '因贵司暂未与我方建立首营合作关系，暂无法领取！如有疑问，请咨询平台客服 电话 027-59356195。',
			icon: 'none',
			duration: 3000,
		});
		return;
	}

	try {
		await collectCouponApi(item.couponId, item.companyCode);
		emit('queryList', sub.value);
	} catch (error) {
		console.error('领取优惠券失败:', error);
		showToast({
			message: '领取失败，请重试',
			icon: 'none',
			duration: 2000,
		});
	}
};

// 去凑单 - SEO 项目中使用 router
const toCollect = item => {
	try {
		setStorageSync('couponDetail', {
			...item,
			companyId: sub.value.companyId,
			companyCode: sub.value.companyCode,
		});

		close();

		// Nuxt4 中使用 navigateTo
		navigateTo('/buyCar/components/collectList');
	} catch (error) {
		console.error('跳转失败:', error);
	}
};

// 获取公司名称
const getName = code => {
	const lists = getMutilData();
	const company = lists.find(item => item.companyCode === code);
	return company?.websiteName || '';
};

// 更新优惠券选择
const changeCoupon = ids => {
	emit('changeCoupon', sub.value, ids);
};

const emit = defineEmits(['queryList', 'changeCoupon']);

// 暴露方法给父组件
defineExpose({
	open,
	close,
});
</script>

<style scoped lang="scss">
.popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999;
	display: flex;
	align-items: flex-end;
}

.wrap {
	position: relative;
	width: 100%;
	font-size: 1rem;
	background: #fff;
	border-radius: 0.67rem 0.67rem 0 0;
	max-height: 90vh;
	overflow: hidden;

	.title {
		font-size: 1.33rem;
		line-height: 4rem;
		text-align: center;
		color: #222222;
		position: relative;

		.close {
			position: absolute;
			right: 1rem;
			top: 0;
			font-size: 2rem;
			color: #aaa;
			cursor: pointer;
			width: 2rem;
			height: 2rem;
			line-height: 2rem;
			text-align: center;
		}
	}
}

.scroll-content {
	height: calc(90vh - 4rem);
	overflow-y: auto;
	padding: 0 0.67rem 0.67rem;
}

.content {
	margin-bottom: 1rem;

	&:before {
		content: '';
		display: block;
		width: 100%;
		height: 0.42rem;
		background: #54c8d0;
		border-radius: 0.5rem 0.5rem 0rem 0rem;
	}

	.top {
		padding-top: 0.5rem;
	}
}

.flex {
	display: flex;
	align-items: flex-start;
}

.rel {
	position: relative;
}

.left {
	width: 9.7rem;
	margin-right: 2rem;
	text-align: center;
	flex-shrink: 0;

	span {
		display: block;
	}

	.tips {
		line-height: 1.5rem;
		text-align: left;
		color: #909399;
		font-size: 0.83rem;
	}

	.price {
		position: relative;
		top: 0.4rem;
		font-size: 2rem;
		font-weight: bold;
		color: #f56c6c;

		i {
			margin-right: 0.3rem;
			font-style: normal;
			font-size: 1rem;
		}
	}

	.price-tag {
		color: #54c8d0 !important;

		&.font10 {
			position: relative;
			top: -0.2rem;
			font-size: 0.83rem;
		}
	}
}

.right {
	position: relative;
	flex: 1;
	min-width: 0;

	.ylq {
		position: absolute;
		right: 0;
		top: 1rem;
		font-size: 5rem;
		z-index: 99;
		color: #54c8d0;
		transform: rotate(-45deg);
	}

	span {
		display: block;
		margin-bottom: 0.5rem;
		line-height: 1.5rem;
		color: #303133;
		font-size: 0.83rem;
	}

	.flex {
		align-items: center;
	}

	.icon-dingdan_quan {
		position: relative;
		left: -0.8rem;
		top: -0.3rem;
		font-size: 2.4rem;
		color: #eb3535;
		margin-right: 0.5rem;
	}
}

.btn-mini {
	font-size: 0.83rem !important;
	padding: 0 1rem !important;
	height: 2rem !important;
	line-height: 2rem !important;
}

.btn-radius {
	border-radius: 10rem;
	background: #54c8d0;
	color: #fff;
	border: none;
	cursor: pointer;
	float: right;

	&:active {
		opacity: 0.8;
	}
}

.go-collect {
	position: relative;
	z-index: 111;
	float: right;
	margin-top: 0.8rem;
	background: none !important;
	border: 1px solid #54c8d0 !important;
	color: #54c8d0;

	&:active {
		opacity: 0.8;
	}
}

.coupon-tips {
	position: absolute;
	left: 1rem;
	bottom: -1rem;
	color: #777;
	font-size: 0.75rem;
}

.font10 {
	font-size: 0.83rem;
}
</style>
